import * as React from 'react'
import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const CheckBoxFillIcon = (props: IconPropsType): React.ReactElement => {
   const { height = 16, width = 16, fill = colors['base-white'] } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         fill='none'
         viewBox='0 0 16 16'
      >
         <rect width='16' height='16' fill='#1570EF' rx='4'></rect>
         <path
            fill={fill}
            fillRule='evenodd'
            d='M12.354 4.646a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L6.5 9.793l5.146-5.147a.5.5 0 0 1 .708 0'
            clipRule='evenodd'
         ></path>
      </svg>
   )
}

export default CheckBoxFillIcon
